import { Component } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

import { componentOutletConfigFactory } from '@recruitee/common';

import { DataTableRow, TableCellFactory } from '../data-table.types';
import { EMPTY_CELL } from './text-cell.component';

/*
 eslint-disable
 @typescript-eslint/consistent-type-assertions,
 @angular-eslint/no-inputs-metadata-property,
*/

@Component({
  standalone: true,
  template: `<div [innerHTML]="value"></div>`,
  host: {
    '[class]': 'class',
  },
  inputs: HtmlCellComponent.NgInputs,
})
export class HtmlCellComponent {
  public static NgInputs = ['value' as const, 'class' as const];

  public value: any;
  public class: string | number;
}

export const htmlCellFactory =
  <Key extends Extract<keyof Row, string | number>, Row extends DataTableRow>(
    key: Key,
    transformFn: (value: Row[Key]) => SafeHtml,
  ): TableCellFactory<Row> =>
  ({ row }) => {
    const value = transformFn(row[key]);

    if (value === undefined || value === null) return EMPTY_CELL;
    return componentOutletConfigFactory(HtmlCellComponent, { inputs: { value, class: key } });
  };
